import React, {Component} from "react";

import {connect} from "react-redux";

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
// Redux Store
import {toggleRightSidebar} from "../../store/actions";
import {getCart} from "../../store/cart/actions";
import WalletMenu from "../CommonForBoth/TopbarDropdown/WalletMenu";
import HeaderLogo from "./HeaderLogo";

// Import menuDropdown

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {isSearch: false};
        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleRightbar = this.toggleRightbar.bind(this);
        this.toggleFullscreen = this.toggleFullscreen.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
        props.getCart();
    }

    toggleSearch = () => {
        this.setState({isSearch: !this.state.isSearch});
    };

    /**
     * Toggle sidebar
     */
    toggleMenu() {
        this.props.openLeftMenuCallBack();
    }

    /**
     * Toggles the sidebar
     */
    toggleRightbar() {
        this.props.toggleRightSidebar();
    }

    toggleFullscreen() {
        if (
            !document.fullscreenElement &&
            /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                );
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    render() {
        const isProd = this.props.env.API_ENV === "production";
        const isTokenManagement = this.props.env.VARIANT === "TOKEN_MGMT";
        const showWalletDropdown = !isTokenManagement;
        return (
            <React.Fragment>
                <header id="page-topbar">
                    <div className="navbar-header">
                        <HeaderLogo />
                        {!isProd && <div className="font-size-14 badge badge-danger"><b>TEST ENVIRONMENT</b></div>}
                        <div className="d-flex">
                            {showWalletDropdown && <WalletMenu/>}
                            <ProfileMenu/>
                            <button
                                type="button"
                                className="btn btn-sm px-3 font-size-16 d-lg-none header-item waves-effect waves-light"
                                data-toggle="collapse"
                                onClick={this.toggleMenu}
                                data-target="#topnav-menu-content">
                                <i className="fa fa-fw fa-bars"/>
                            </button>
                        </div>
                    </div>
                </header>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const {layoutType} = state.Layout;
    const {user, profile} = state.User;
    const {items} = state.Cart;
    const {env} = state.Variables;
    return {layoutType, user, profile, items, env};
};

export default connect(mapStateToProps, {toggleRightSidebar, getCart})(Header);
